import React from 'react';
import Websocket from 'react-websocket';
import { connect } from 'react-redux';

import { getConfig } from '../functions/getConfig';
import { getCookie } from '../functions/getCookie';
import { UPDATE_TICKET } from '../user/containers/CandidateTicketsPage/constants';

let self;
class PrimusHandler extends React.Component {
  state = {
    isConnected: false,
  };

  static sendRequest = (data, noSession) => {
    let interval = setInterval(() => {
      if (self.state.isConnected) {
        clearInterval(interval);
        let details;
        if (!noSession) {
          details = { ...data, _session: getCookie('fsSession') };
        } else {
          details = { ...data };
        }
        self.refWebSocket.sendMessage(JSON.stringify(details));
      }
    }, 200);
  };

  static isWebsocketConnected = () => {
    return self.state.isConnected;
  };

  handleData = (data) => {
    if (String(data)?.includes('primus::ping::'))
      return self.refWebSocket.sendMessage(String(data).replace('ping', 'pong'));
    this.props.storePrimusResponse(JSON.parse(data));
  };

  handleClose = (err) => {
    this.setState({
      isConnected: false,
    });
  };

  handleOpen = () => {
    self.setState({
      isConnected: true,
    });
  };

  render = () => {
    self = this;
    return (
      <Websocket
        url={`${getConfig().WEBSOCKET_ROOT_URL}/live`}
        onMessage={this.handleData.bind(this)}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        debug={true}
        ref={(Websocket) => {
          this.refWebSocket = Websocket;
        }}
      />
    );
  };
}

const mapStateToProps = (state) => {
  return {
    planDetails: state.data.planDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storePrimusResponse: (data) => {
      if (data.type === 'ticket') {
        dispatch({ type: UPDATE_TICKET, payload: data });
      } else {
        dispatch({ type: 'STORE_PRIMUS_RESPONSE', payload: data });
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrimusHandler);
